<template>
  <div class="d-flex flex-column align-center">
    <v-sheet
      class="rounded-circle pa-1 header-logo"
      :height="xsOnly ? '100px' : '120px'"
      :width="xsOnly ? '100px' : '120px'"
    >
      <v-sheet
        class="d-flex align-center justify-center rounded-circle pa-2"
        color="#f4f7fa"
        height="100%"
        width="100%"
      >
        <v-img :src="logo" height="100%" width="100%" contain></v-img>
      </v-sheet>
    </v-sheet>

    <div class="text-h6 text-md-h5 font-weight-medium mt-3">
      {{ title }}
    </div>

    <div class="d-flex align-center mt-1">
      <div class="text-body-1 font-weight-regular">
        {{ text }}
      </div>

      <v-icon color="#f9b648" size="16" right> mdi-key-variant </v-icon>
    </div>

    <div class="text-body-2 font-weight-medium mt-2">
      {{ info }}
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderHome",
  data: () => ({
    title: "Canto a Canto Imóveis",
    text: "Você tem um sonho, nós temos a chave!",
    info: "CRECI 10758 J",
  }),
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    logo() {
      const mes = new Date().getMonth() + 1; // 1-12

      switch (mes) {
        case 10:
          return "/img/outubro-rosa-canto-a-canto.png";
        case 11:
          return "/img/novembro-azul-canto-a-canto.png";
        default:
          return "/img/canto-a-canto.png";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header-logo {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -4px rgba(0, 0, 0, 0.1);
}
</style>
